import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EntertainmentIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EntertainmentGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.5381 19.4437H4.54145C3.43779 19.4437 2.54004 18.5454 2.54004 17.4417V6.55858C2.54004 5.45492 3.43779 4.55664 4.54145 4.55664H20.5381C21.6418 4.55664 22.54 5.45492 22.54 6.55858V17.4417C22.54 18.5454 21.6418 19.4437 20.5381 19.4437ZM4.54145 5.66354C4.04799 5.66354 3.64695 6.06457 3.64695 6.55857V17.4417C3.64695 17.9357 4.04798 18.3368 4.54145 18.3368H20.5381C21.0316 18.3368 21.4331 17.9357 21.4331 17.4417V6.55858C21.4331 6.06458 21.0316 5.66355 20.5381 5.66355L4.54145 5.66354Z"
        fill="#696969"
      />
      <path
        d="M10.6224 15.3241C10.5257 15.3241 10.4284 15.2982 10.3419 15.2474C10.1727 15.1479 10.069 14.9674 10.069 14.7707V9.29666C10.069 9.101 10.1716 8.92049 10.3397 8.82103C10.5073 8.72159 10.7148 8.71835 10.8867 8.81022L15.8586 11.5137C16.0359 11.6099 16.1467 11.7958 16.1478 11.9969C16.1488 12.199 16.0402 12.385 15.8635 12.4833L10.8916 15.2538C10.8078 15.3003 10.7154 15.3241 10.6224 15.3241ZM11.1759 10.2274V13.8291L14.4469 12.0056L11.1759 10.2274Z"
        fill="#696969"
      />
    </svg>
  );
};

export default EntertainmentIcon;
